module.exports = __webpack_public_path__ + "img/9788958286554.a0aa4c28.jpg";